import { Controller } from '@hotwired/stimulus'
import { render, cancel } from 'timeago.js'

export default class extends Controller {
  connect () {
    render(this.element, 'en_US', { minInterval: 60 })
  }

  disconnect () {
    cancel(this.element)
  }
}
